import { createSelector } from 'reselect';

export interface CitiesState {
  loading: boolean;
  cities: any[];
  region: any;
  error: string;
}

export const initialState: CitiesState = {
  loading: false,
  cities: [],
  region: null,
  error: '',
};

const getCities = ({ cities }: any): CitiesState => cities;

export const citiesSelectors = {
  getCities: createSelector(
    [getCities],
    ({ cities }) => cities,
  ),

  getLoading: createSelector(
    getCities,
    ({ loading }) => loading,
  ),

  getRegion: createSelector(
    getCities,
    ({ region }) => region,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Cities/services/selectors.ts